<template>
  <div class="contacts-page">
    <div :class="loading ? 'hidden' : ''">
      <filter-results
        :refresh="key"
        @updateFilters="updateFilters"
        @updateSearch="updateSearch"
        @fetchDataComplete="fetchDataComplete"
        @selectedItemsChange="selectedItemsChange"
        :filtersFromParams="filtersFromParams"
        @companyId="bulkAddToCompany"
      ></filter-results>
      <upload-contacts
        :isOpen="importOpen"
        @contactUploadComplete="contactUploadComplete"
        @contactUploadCancelled="contactUploadCancelled"
      ></upload-contacts>
    </div>

    <div class="contacts-page-loader" :class="loading ? '' : 'hidden'">
      <loading></loading>
    </div>

    <!-- Save as segment modal -->
    <modal
      :title="$t('ui.segments.create_modal.title')"
      :open="createSegmentOpen"
      @save="createSegmentCommit()"
      @cancel="closeCreateSegmentModal()"
    >
      <field
        v-model="createSegmentName"
        :label="$t('ui.segments.create_modal.field_label')"
        :autofocus="true"
      />
    </modal>
  </div>
</template>

<script>
import SegmentsApi from "@/api/Segments";
import ContactsApi from "@/api/Contacts";
import UploadContacts from "@/components/pages/contacts/UploadContacts";
import Ui from "@/classes/Ui";
import Modal from "@/components/helpers/Layout/NewModal";
import Field from "@/components/helpers/DataInput/Field";
import Loading from "@/components/helpers/Specific/Loading.vue";
import FilterResults from "@/components/helpers/DataDisplay/FilterResults/Contacts";

export default {
  components: { UploadContacts, FilterResults, Loading, Modal, Field },
  props: {
    filtersFromParams: {
      type: [Object, Boolean],
      default: false,
    },
  },
  data() {
    return {
      segmentsApi: new SegmentsApi(),
      importOpen: false,
      key: 0,
      loading: false,
      createSegmentOpen: false,
      createSegmentName: "",
      segmentOriginal: {},
      segmentSave: {},
      selectedItems: [],
    };
  },
  beforeMount() {
    this.loading = true;
  },
  mounted() {
    if (this.$route.meta.createSegment) {
      Ui.setPageLevel("3");
      Ui.setSubtitle({ link: { name: "segments" } });
    } else {
      Ui.setPageLevel("2");
    }
    Ui.setSecondaryHeaderTabs({});
    Ui.setTitle({ label: "ui.pages.contacts" });
    this.setHeaderButtons();
  },
  methods: {
    setHeaderButtons() {
      Ui.setHeaderButtons([
        {
          name: "importcontacts",
          action: "contacts.import",
          classes: "btn-tertiary",
          function: this.startImporter,
        },
        {
          name: "saveassegment",
          action: "contacts.save_as_segment",
          classes: "btn-primary",
          disabled: this.selectedItems.length != 0,
          function: this.startCreateSegment,
        },
      ]);
    },
    selectedItemsChange(items) {
      this.selectedItems = items;
      this.setHeaderButtons();
    },
    bulkAddToCompany(payload) {
      let contactIds = [];
      this.selectedItems.forEach((item) => {
        contactIds.push(item.id);
      });
      let companyId = payload;
      let api = new ContactsApi();
      let params = { companyId, contactIds };
      api.updateContactsCompany(params);
      this.key++;
    },
    updateFilters(filters) {
      this.segmentSave.filters = filters;
      this.segmentSave = JSON.parse(JSON.stringify(this.segmentSave));
    },
    updateSearch(searchkeywords) {
      this.segmentSave.search = searchkeywords;
      this.segmentSave = JSON.parse(JSON.stringify(this.segmentSave));
    },
    async createSegment() {
      this.segment = await this.segmentsApi.updateSegment(
        this.id,
        this.segmentSave
      );
      this.segmentOriginal = JSON.parse(JSON.stringify(this.segment));
      this.segmentSave = JSON.parse(JSON.stringify(this.segment));
    },
    startImporter() {
      this.importOpen = true;
    },
    contactUploadComplete(results) {
      this.importOpen = false;
      this.key++;
    },
    contactUploadCancelled() {
      this.importOpen = false;
      this.key++;
    },
    startCreateSegment() {
      this.createSegmentName = "";
      this.createSegmentOpen = true;
    },
    async createSegmentCommit() {
      let payload = {
        name: this.createSegmentName,
        filters: this.segmentSave.filters,
        search: this.segmentSave.search,
      };

      let resource = await this.segmentsApi.createSegment(payload);

      this.$router.push({ name: "segment_edit", params: { id: resource.id } });
    },
    closeCreateSegmentModal() {
      this.createSegmentOpen = false;
    },
    fetchDataComplete() {
      this.loading = false;
    },
  },
};
</script>

<style lang="sass" scoped>
.contacts-page
  .contacts-page-loader
    z-index: 200
    position: absolute
    top: 0
    left: 0
    margin: 0 auto
    width: 100%
    height: 100%
  .hidden
    visibility: hidden
</style>



// WEBPACK FOOTER //
// Contacts.vue?79e36e7f